/* eslint-disable react/no-array-index-key */
import React from 'react'
import { BGC_FIELDS, getBgcVariableTitle } from 'utils/constants/bgcFields'
import ScoreWithLastUpdate from "../ScoreWithLastUpdate"
import Section, { SectionContent, SectionHeader } from "../../Section"
import ComplianceListVariableReport from "./ComplianceList"
import FrontierZoneVariableReport from "./FrontierZone"
import NegativeMediaZoneVariableReport from "./NegativeMedia"
import PepVariableReport from "./Pep"
import RestrictionListVariableReport from "./RestrictionData"
import ProcessDataVariableReport from "./ProcessData"
import CompanyDataVariableReport from "./CompanyData"
import FamilyRelationsVariableReport from "./FamilyRelations"
import FinancialSituationReport from "./FinancialSituation"

const BgcVariables = ({ field, bgc_info, score_data }) => {
 
  const fieldComponentMapping = {
    [BGC_FIELDS.negative_media]: { component: NegativeMediaZoneVariableReport, props: { negativeMediaData: bgc_info } },
    [BGC_FIELDS.pep]: { component: PepVariableReport, props: { pepData: bgc_info } },
    [BGC_FIELDS.restriction_data]: { component: RestrictionListVariableReport, props: { restrictionsData: bgc_info } },
    [BGC_FIELDS.process_data]: { component: ProcessDataVariableReport, props: { processData: bgc_info } },
    [BGC_FIELDS.family_relation_data]: {
      component: FamilyRelationsVariableReport,
      props: { familyRelationsData: bgc_info },
    },
    [BGC_FIELDS.company_data]: { component: CompanyDataVariableReport, props: { companyData: bgc_info } },
    [BGC_FIELDS.compliance_list]: { component: ComplianceListVariableReport, props: { complianceListData: bgc_info } },
    [BGC_FIELDS.frontier_zone]: { component: FrontierZoneVariableReport, props: { frontierZoneData: bgc_info } },
    [BGC_FIELDS.financial_situation]: { component: FinancialSituationReport, props: { financial_situation: bgc_info } },
  }

  return (
    <Section>
      <SectionHeader text={getBgcVariableTitle(field)} variant='secondary' />
      {
        bgc_info || field === BGC_FIELDS.compliance_list ? (
          <SectionContent>
            {Object.keys(fieldComponentMapping).includes(field) &&
              fieldComponentMapping[field].component(fieldComponentMapping[field].props)
            }

            <ScoreWithLastUpdate bgc_info={bgc_info} score_data={score_data} />
          </SectionContent>
        ) : (
          <SectionContent>
            <span>Nenhuma informação encontrada.</span>
          </SectionContent>
        )
      }
    </Section>
  )
}

export default BgcVariables
